import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { ExclusionEquipos } from "./solicitud-equipo.component";
import { ExclusionEquiposService } from "./solicitud-equipo.service";
import {FileUploadModule} from "ng2-file-upload/ng2-file-upload";

@NgModule({
    declarations: [ExclusionEquipos],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        FileUploadModule],
    providers: [ExclusionEquiposService],
    exports: [ExclusionEquipos]

})

export class SolicitudEquiposModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-equipo.module.ts